// extracted by mini-css-extract-plugin
module.exports = {"top":"SpotlightSection_top__35NTO","title":"SpotlightSection_title__2iwLR","more":"SpotlightSection_more__3eUld"};